import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({
  initialize() {
    this.choices = [
      { option: '', readable: 'All Statuses' },
      { option: 'pre_transit', readable: 'Pre Transit' },
      { option: 'in_transit', readable: 'In Transit' },
      { option: 'out_for_delivery', readable: 'Out for Delivery' },
      { option: 'delivered', readable: 'Delivered' },
      { option: 'return_to_sender', readable: 'Return to Sender' },
      { option: 'failure', readable: 'Failure' },
      { option: 'cancelled', readable: 'Cancelled' },
      { option: 'error', readable: 'Error' },
    ];
    this.paramKey = 'status';
    this.set('currentChoice', this.choices[0]);
  },
});



// WEBPACK FOOTER //
// ./app/models/tracker_status_dropdown_selection.js